import getLocalString from "constants/Localization";
import { GetProductGroupsDocument, useUpdateProductGroupMutation } from "generated/graphql";
import { usePaginatedVariables } from "hooks/strings/usePaginatedVariables";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateProductGroup() {
  const { offset } = usePaginatedVariables();
  const [mutation, { data, loading, error }] = useUpdateProductGroupMutation({
    refetchQueries: [
      {
        query: GetProductGroupsDocument,
        variables: {
          page: offset.page,
          first: offset.first,
        },
      },
    ],
  });

  const [updateProductGroup, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateProductGroup",
    },
    {
      successMessage: getLocalString("product-groups.update-success"),
      failureMessage: getLocalString("product-groups.update-failure"),
    }
  );

  return [updateProductGroup, context] as const;
}
